import Skeleton from "react-loading-skeleton";

const KycDetailsSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-[12px]">
      {/* User Info */}
      <div className="flex flex-col py-[8px] px-[12px] space-y-[12px] border border-border-subtle bg-bg-base rounded-lg">
        <Skeleton height={18} width={180} />

        <Skeleton height={14} />
        <Skeleton height={14} />
        <Skeleton height={14} />
        <Skeleton height={14} />

        <div className="border-b border-border-subtle"></div>

        <Skeleton height={14} />
        <Skeleton height={14} />
        <Skeleton height={14} />
      </div>

      {/* POI Images */}
      <div className="flex flex-col py-[8px] px-[12px] space-y-[12px] border border-border-subtle bg-bg-base rounded-lg">
        <Skeleton height={18} width={200} />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <div className="flex flex-col gap-2">
            <Skeleton height={10} width={80} />
            <Skeleton height={120} borderRadius={8} />
          </div>

          <div className="flex flex-col gap-2">
            <Skeleton height={10} width={80} />
            <Skeleton height={120} borderRadius={8} />
          </div>
        </div>
      </div>

      {/* POA Images */}
      <div className="flex flex-col py-[8px] px-[12px] space-y-[12px] border border-border-subtle bg-bg-base rounded-lg">
        <Skeleton height={18} width={220} />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div className="flex flex-col gap-2">
            <Skeleton height={10} width={120} />
            <Skeleton height={120} borderRadius={8} />
          </div>

          <div className="flex flex-col gap-2">
            <Skeleton height={10} width={120} />
            <Skeleton height={120} borderRadius={8} />
          </div>
        </div>
      </div>

      {/* KYC Status */}
      <div className="flex flex-col py-[8px] px-[12px] space-y-[12px] border border-border-subtle bg-bg-base rounded-lg">
        <Skeleton height={18} width={120} />

        <Skeleton height={14} />
        <Skeleton height={14} />

        <div className="border-b border-border-subtle"></div>

        <Skeleton height={14} />
        <Skeleton height={14} />
        <Skeleton height={14} />

        <div className="border-b border-border-subtle"></div>

        <Skeleton height={14} />
        <Skeleton height={30} borderRadius={6} />

        <Skeleton height={14} />
        <Skeleton height={14} />
      </div>

      {/* Actions */}
      <div className="flex flex-col py-[8px] px-[12px] space-y-[12px] border border-border-subtle bg-bg-base rounded-lg">
        <Skeleton height={18} width={120} />

        <div className="grid grid-cols-1 gap-4">
          <div>
            <Skeleton height={10} width={160} />
            <Skeleton height={36} borderRadius={6} />
          </div>

          <div>
            <Skeleton height={10} width={180} />
            <Skeleton height={36} borderRadius={6} />
          </div>

          <div>
            <Skeleton height={10} width={150} />
            <Skeleton height={36} borderRadius={6} />
          </div>

          <div className="flex justify-center pt-2">
            <Skeleton height={36} width={180} borderRadius={8} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default KycDetailsSkeleton;
